import { PaymentLabels } from '../components/organisms/Cart/interfaces'
import { MerchantStatus } from '../store/slices/session'
import { getDaysToDelivery } from './utils'

export const INVOICE_PAGE_SIZE = 15

export const SECOND_MS = 1000
export const MINUTE_MS = SECOND_MS * 60

export const CX_WHATSAPP_NUMBER = '552136093614' //TODO: move this to an enviroment variable.

export const CX_WHATSAPP_LINK = `https://wa.me/${CX_WHATSAPP_NUMBER}`

export const WHATSAPP_PROFILE_EDIT_MESSAGE = encodeURIComponent(
  'Oi, gostaria de alterar meus dados cadastrais.'
)

export const WHATSAPP_CREDIT_MESSAGE = encodeURIComponent(
  'Oi, gostaria de saber sobre a análise de crédito do meu pedido.'
)

export const CLUBBI_PROFILE_EDIT_LINK = `https://wa.me/${CX_WHATSAPP_NUMBER}?text=${WHATSAPP_PROFILE_EDIT_MESSAGE}`

export const CLUBBI_CREDIT_LINK = `https://wa.me/${CX_WHATSAPP_NUMBER}?text=${WHATSAPP_CREDIT_MESSAGE}`

export const SIGN_UP_LINK = `https://api.whatsapp.com/send/?phone=${CX_WHATSAPP_NUMBER}&text=Ol%C3%A1%21+Quero+fazer+meu+cadastro+Clubbi%21&type=phone_number&app_absent=0`

export const whatsappHelpLinkGenerator = (merchantCode = '', shopperPlanId: string) =>
  `https://api.whatsapp.com/send?phone=${CX_WHATSAPP_NUMBER}&text=Ol%C3%A1!%20Sou%20o%20cliente%20${merchantCode}%20e%20preciso%20de%20ajuda%20com%20o%20pedido%20da%20entrega%20%23${shopperPlanId}.`

export const whatsappBillingCXLinkGenerator = (merchantCode = '', shopperPlanId: string) =>
  `https://api.whatsapp.com/send?phone=${CX_WHATSAPP_NUMBER}&text=Ol%C3%A1!%20Sou%20o%20cliente%20${merchantCode}%20e+gostaria+de+enviar+o+comprovante+de+pagamento+do+pedido+vinculado+%C3%A0+entrega%20%23${shopperPlanId}.`

export const whatsappHelpCXLinkGenerator = (merchantCode = '') =>
  `https://api.whatsapp.com/send/?phone=${CX_WHATSAPP_NUMBER}&text=Olá.%20Fiz%20um%20pedido%20e%20está%20em%20análise.%20Meu%20código%20é%20${merchantCode}%20e%20tenho%20uma%20dúvida.&type=phone_number&app_absent=0.`

export const whatsappOutsourcedNfCXLinkGenerator = (merchantCode = '', shopperPlanId: string) =>
  `https://api.whatsapp.com/send?phone=${CX_WHATSAPP_NUMBER}&text=Ol%C3%A1!%20Sou%20o%20cliente%20${merchantCode}%20e+gostaria+de+solicitar+a+nota+fiscal+para+produtos+parceiros+do+pedido+vinculado+%C3%A0+entrega%20%23${shopperPlanId}.`

export const instantPaymentData: PaymentLabels[] = [{ id: 2, label: 'Pagamento à vista via Pix' }]

export const paymentTypesData: PaymentLabels[] = [
  { id: 2, label: 'Pix' },
  { id: 0, label: 'Boleto' },
  { id: 1, label: 'Cartão de crédito' },
]

export const invoiceTypesData: PaymentLabels[] = [
  { id: 2, label: 'Nota Fiscal - DANFE', subLabel: 'Com CNPJ na nota' },
]

export const orderSuccessfulSteps: string[] = ['Pedido aprovado', 'Coleta', 'Entrega', 'Pagamento']

export const orderUnderReviewSteps: string[] = [
  'Análise de crédito',
  'Pedido aprovado',
  'Coleta',
  'Entrega',
  'Pagamento',
]

export const pendingOrderMessage =
  'Obrigado pela preferência! Você receberá os produtos no seu estabelecimento. \nAtualizações do pedido serão realizadas via WhatsApp.'

export const creditReviewOrderMessage =
  'Seu pedido excedeu o limite atualmente disponível e ainda não foi finalizado. No entanto, não se preocupe, nós iremos avaliá-lo e entraremos em contato dentro de 1 (um) dia útil para confirmar e informar a nova data de entrega. Caso seja aprovado, os detalhes do pedido poderão ser visualizados acessando a aba de '

export const creditReviewLinkTxt = 'Saiba mais sobre a análise.'

export const creditReviewOrderTitleText = 'Seu pedido está sob análise de crédito'
export const confirmedOrderTitleText = 'Recebemos o seu pedido!'

export const urlImages =
  'https://res.cloudinary.com/dti85ldyv/image/upload/c_scale,h_120/f_png/d_product-thumb_ybwmng.png/category'

export const blockingStatuses = [
  MerchantStatus.DEACTIVATED,
  MerchantStatus.DEFAULTED,
  MerchantStatus.NEGATIVATED,
]

export const GOOD_GRADES = [
  'Preço dos produtos',
  'Tempo de entrega',
  'Praticidade',
  'Variedade dos produtos',
  'Não ter pedido mínimo',
  'Prazo de pagamento',
  'Suporte',
  'Valor da taxa de entrega',
]

export const BAD_GRADES = [
  'Preço dos produtos',
  'Produtos danificados',
  'Navegação e solicitação de pedidos',
  'Validade dos produtos',
  'Maior variedade de produtos',
  'Suporte',
  'Tempo de entrega',
  'Faltas de produto',
  'Produtos errados',
  'Valor da taxa de entrega',
]

export const NPS_GRADES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

export const WHATSAPP_API_URL =
  'https://api.whatsapp.com/send/?text=Cansado+de+ir+sempre+aos+atacados%3F+A+Clubbi+entrega+tudo+que+precisa+na+sua+loja+e+ainda+te+ajuda+a+economizar.+Compre+com+os+melhores+pre%C3%A7os+de+cada+rede%2C+sem+pedido+m%C3%ADnimo+e+com+v%C3%A1rias+formas+de+pagamento.+Com+a+minha+indica%C3%A7%C3%A3o+voc%C3%AA+ganha+R%2430+na+primeira+compra%21+Se+inscreva+em+clubbi.com.br+para+eles+entrarem+em+contato%21&app_absent=0'

export const CUSTOM_PRODUCTS_QUANTITY = 20

export const SEARCH_RESULTS_QUANTITY = 4

export const CUSTOM_PRODUCTS_QUANTITY_PER_PAGE = 50

export const TAX_BENEFIT_MESSAGE =
  'Este produto tem sua base de cálculo do ICMS reduzida em 41.176%, conforme Decreto Estadual Nº 7.799/00'

export const TAX_BENEFIT_LINK =
  'https://clubbihelp.zendesk.com/hc/pt-br/articles/19191142358804-Tributa%C3%A7%C3%A3o-Fiscal-na-Bahia'

export const DELAY_TO_SHOW_CARD = 1000

export const DELAY_TO_HIDE_CARD = 5000

export const infoNavigationSteps = [
  {
    title: 'Conheça a nova forma de navegar no site da Clubbi!',
    description: 'Começando, aqui é onde você encontra Ofertas e Categorias.',
  },
  {
    title: 'Busque muito mais rápido!',
    description: 'Experimente a nova área de busca, mais rápida e muito mais eficiente.',
  },
  {
    title: 'Lista de Compras e Perfil',
    description:
      'Nesta área acesse seu perfil e faça a busca rápida por vários produtos ao mesmo tempo.',
  },
  {
    title: 'Missões e Carrinho',
    description: 'Por último, aqui ficou o acesso direto a Missões e ao seu Carrinho de Compras.',
  },
]

export const infoNavigationStepsDesktop = [
  {
    title: 'Conheça a nova forma de navegar no site da Clubbi!',
    description: 'Começando, aqui é onde você encontra Ofertas e Categorias.',
  },
  {
    title: 'Busque muito mais rápido!',
    description: 'Experimente a nova área de busca, mais rápida e muito mais eficiente.',
  },
  {
    title: 'Lista de Compras',
    description:
      'Faça buscas rápidas por diversos produtos ao mesmo tempo. Basta copiar e colar sua lista de compras.',
  },
  {
    title: 'Missões e Carrinho',
    description: 'Por último, aqui ficou o acesso direto a Missões e ao seu Carrinho de Compras.',
  },
]

export const categoriesTags = [
  'Mercearia',
  'Padaria e Matinais',
  'Biscoitos, Salgadinhos e Doces',
  'Laticínios',
  'Bebidas Alcoólicas',
  'Bebidas Não Alcoólicas',
  'Limpeza',
  'Higiene e Beleza',
  'Bazar e Utilidades',
  'Bazar em Geral',
  'Saudáveis',
]

export const HITS_PER_PAGE = 5

export const ALGOLIA_RESULTS = 1

export const BEACON_CONVERSION_URL =
  'https://events.newtail-media.newtail.com.br/v1/beacon/conversion'

export const WARNING_CUTOFF_START_TIME = 20

export const WARNING_CUTOFF_END_TIME = 6

export const instantPaymentMessage =
  'No momento da entrega, uma pessoa responsável deve estar disponível para efetuar o pagamento.'

export const noDeadlineAvailableMessage = 'Informação de prazo de pagamento indisponível'

export const DEFAULT_DELIVERY_FEE = 15
export const MOCK_DELIVERY_FEE = 30

export enum DELIVERY_TYPE_ENUM {
  fast = 'fast',
  twoDays = 'twoDays',
}

export const DELIVERY_TYPES = {
  fast: { value: DEFAULT_DELIVERY_FEE, daysToDelivery: 1 },
  twoDays: {
    value: DEFAULT_DELIVERY_FEE,
    get daysToDelivery(): number {
      return getDaysToDelivery()
    },
  },
}

export const MERCHANT_CODE_CHARACTERS = 5

export const WITHOUT_PRICE = '--'

export const REFRESH_TOKEN_INTERVAL = 3600000

export const PRICING_GROUP_IDS_SALVADOR = [16, 75]

export const PRICING_GROUP_IDS_IN_GET_MORE_FOR_LESS = [
  70, 71, 72, 73, 74, 76, 78, 81, 82, 83, 85, 86, 87, 88, 89, 90, 91, 92, 93,
]

export const PRICING_GROUP_IDS_IN_ACTIVE_DELIVERY_MISSION = [
  70, 71, 72, 73, 74, 76, 78, 81, 82, 83, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94,
]

export const EBD_SUPPLIER = 'EBD'
export const EBD_SUPPLIER_OFERTAO = 'Ofertao-EBD'
export const GARCIA_SUPPLIER = 'Garcia-Distribuidora'
export const GARCIA_SUPPLIER_OFERTAO = 'Ofertao-Garcia'
export const CLUBBI_SUPPLIER = 'clubbi'
export const DISPROL_SUPPLIER = 'Disprol'
export const DISPROL_SUPPLIER_OFERTAO = 'Ofertao-Disprol'

export const BLOCKED_EDITION_SUPPLIERS = [
  EBD_SUPPLIER,
  EBD_SUPPLIER_OFERTAO,
  GARCIA_SUPPLIER,
  GARCIA_SUPPLIER_OFERTAO,
  DISPROL_SUPPLIER,
  DISPROL_SUPPLIER_OFERTAO,
]

export const TWO_DAYS_STORES = [
  EBD_SUPPLIER,
  EBD_SUPPLIER_OFERTAO,
  GARCIA_SUPPLIER,
  GARCIA_SUPPLIER_OFERTAO,
  DISPROL_SUPPLIER,
  DISPROL_SUPPLIER_OFERTAO,
]

export const DIFFERENT_MODE_ERROR = 6

export const OUTSORCED_SUPPLIERS_WITHOUT_OFERTAO = [EBD_SUPPLIER, GARCIA_SUPPLIER, DISPROL_SUPPLIER]

export const INSTALLMENT_RULES: Record<
  string,
  {
    oneTime: number
    threeTimes: number[]
  }
> = {
  '7': {
    oneTime: 7,
    threeTimes: [4, 7, 10],
  },
  '14': {
    oneTime: 14,
    threeTimes: [7, 14, 21],
  },
  '21': {
    oneTime: 21,
    threeTimes: [14, 21, 28],
  },
  '28': {
    oneTime: 28,
    threeTimes: [21, 28, 35],
  },
}

type DaysMapping = Record<number, number>

interface DeliveryRule {
  first: DaysMapping
  second: DaysMapping
}

export const DAYS_TO_DELIVERY_RULES: DeliveryRule = {
  first: { 0: 2, 1: 2, 2: 2, 3: 2, 4: 4, 5: 4, 6: 3 }, // 00:00 até 15:30
  second: { 0: 3, 1: 3, 2: 3, 3: 5, 4: 5, 5: 4, 6: 3 }, // 15:30 até 00:00
}

export const URLS_ABASTECE_SHOP = {
  APP_STORE_ABASTECE_SHOP: 'https://apps.apple.com/br/app/abasteceshop/id1474129377',
  PLAY_STORE_ABASTECE_SHOP:
    'https://play.google.com/store/apps/details?id=br.com.yandeh.compras&hl=pt_BR',
  APP_STORE_SMART_FORCE:
    'https://play.google.com/store/apps/details?id=br.com.yandeh.smartforce&hl=pt_BR',
}

export const MIGRATION_REQUIRED_MERCHANT_CODES = [
  'DJLOS',
  'DIVVV',
  'HHZYO',
  'BYZLL',
  'SPVNB',
  'ODOCW',
  'KUEDZ',
  'DKIEE',
  'ZQXHZ',
  'HBHOG',
  'YNOMY',
  'HCMIY',
  'QYZES',
  'EOEXD',
  'NEGGE',
  'DOXXR',
  'QVVVV',
  'ZAYUW',
  'GVCOO',
  'SXPHN',
  'NXUBJ',
  'PAOYM',
  'HWUYQ',
  'VKTFH',
  'KOHKK',
  'YOJOC',
  'YFZBT',
  'CEHGC',
  'ZCZXJ',
  'MBXLD',
  'RHRYE',
  'UXNZZ',
  'LGIKO',
  'SVDFV',
  'PVLAK',
  'XNMVT',
  'CQHIE',
  'DIBLT',
  'DFHUK',
  'OCQFT',
  'AZZTZ',
  'VDVUQ',
  'GSZMI',
  'VOXZP',
  'YLOQC',
  'APUEM',
  'XPENJ',
  'NLOJJ',
  'FOICQ',
  'YDXRP',
  'HAIKM',
  'TWCMM',
  'RIGKK',
  'LQDHN',
  'RCVXR',
  'NYXHT',
  'QWYBF',
  'DVZKY',
  'WWTKG',
  'TAAQW',
  'RVOBD',
  'AJBNN',
  'REIGA',
  'SCPKQ',
  'DXLMQ',
  'YRGAK',
  'WZMUY',
  'NKUOW',
  'MRGQU',
  // 'JYRFH', # only pix
  'GXJHZ',
  'QDSKG',
  'KVLLZ',
  'YZHRL',
  'ZJCRH',
  'VCYEE',
  'OMXIO',
  'PDUVR',
  'MPOYE',
  'UATWE',
  'ZXXGY',
  'ZLIDB',
  'TAZJF',
  'ERZVD',
  'RSLZX',
  'WFHZF',
  'GWALR',
  'BNBIC',
  'HYJVH',
  'CWGPB',
  'KJXPT',
  'BNOVP',
  'EWXKY',
  'FSLPH',
  'CROQE',
  'NUYWS',
  'LELJR',
  'UMVMO',
  'NTIDV',
  'NCDPJ',
  'DPPEW',
  'KHZHF',
  'TPQHR',
  'YOUNH',
  'GOTES',
  'JRUBH',
  'QLUIY',
  'WDAGU',
  'XYSCI',
  'WWRWY',
  'LTPUQ',
  'POFLN',
  'ALBJJ',
  'TJWJB',
  'SEFOY',
  'OXFDL',
  'BTQXL',
  'EARMS',
  'XFVWG',
  'XTGTJ',
  'ILMGQ',
  'SHIQE',
  'BHZGG',
  'ATJXZ',
  'FOEAA',
  'UFLVB',
  'OOKRX',
  'DJERD',
  'CIQJR',
  'BOFVD',
  'SJKAI',
  'CPIEK',
  'ZCGUY',
  'YGQBH',
  'WLWOO',
  'QRCAS',
  'DHVKK',
  'WXZLP',
  'CHQYG',
  'NTOTT',
  'IWSNF',
  'DOCGY',
  'TQPLL',
  'UJRDR',
  'BCOEY',
  // 'KWCLN',
  'ZFNYU',
  'OZCEI',
  'DHRIU',
  'OWBQK',
  'DATXD',
  'NJRIM',
  'KVFVB',
  'OGQXL',
  'QFFTP',
  'AZQIC',
  'DLOFN',
  'YTAGI',
  'NQHPX',
  'JUZRV',
  'CHUAW',
  'WAHWC',
  'NTGPN',
  'JYXVF',
  'OMJOK',
  // 'KTBXP',
  'ZEHXL',
  'UAPUO',
  'NWYSO',
  'DAYGK',
  'ZLMFR',
  'ZPGHL',
  'LKNLN',
  'NQBZZ',
  'KLYSG',
  'WDGWS',
  'BRDOC',
  'WBYWQ',
  'ZMDFF',
  'PTNSW',
  'VRDWU',
  'JUCMU',
  'MHEWG',
  'YFJTH',
  'UMHSK',
  'EDPFR',
  'WNPNV',
  'YARUK',
  'NQJDF',
  'SEWDB',
  'JKZLP',
  'VJSNF',
  'PUUAW',
  'ACPIS',
  'VSSIA',
  'WTXFP',
  'EYYNL',
  'SSCRX',
  'ZGLVX',
  'BPXCI',
  'NBODD',
  'AWNGW',
  'AAZEK',
  'ZATLP',
  'ZKTRV',
  'SDOOK',
  'ILLZZ',
  'NYWAC',
  'AKQZT',
  'PMEIA',
  'QHYSW',
  'IVSCU',
  'YBOKW',
  'BKHRT',
  'CPQIQ',
  'VPOZD',
  'YHFNN',
  'ILCOC',
  'SXIKY',
  'YNEUK',
  'LXQTZ',
  'VOLTT',
  'OBXRX',
  'MUXME',
  'NTMFL',
  'RAXPD',
  'GOGRF',
  'MXTRV',
  'LFZOG',
  // 'BAHLN',
  'VJGHJ',
  'VOKMC',
  'LNFOO',
  'FNEPP',
  'FVFGQ',
  'BZOXR',
  'IIFCU',
  'RPXYM',
  'VXXUK',
  'BUSWE',
  'ODZBB',
  'VFMFP',
  'HMYUA',
  'ZSNLH',
  'LGWES',
  'LEEMC',
  'NMJLN',
  'DXEPB',
  'RPLSQ',
  'OZTTL',
  'ZCHBP',
  'SOMRT',
  'FFYPH',
  'LODLR',
  'RJPGS',
  'WDJRR',
  'ABBDD',
  'RETFF',
  'SQDCS',
  'UKAZZ',
  // 'YTYSA',
  'GJWWO',
  'VEAOI',
  'VDUNZ',
  'LOJBP',
  'AANYO',
  'DKUKA',
  'TYLTF',
  'RCUQA',
  'EDJPT',
  'AOXOA',
  'TDCLL',
  'QOEHT',
  'UHFBZ',
  'ZUDPP',
  'ADDNH',
  'EHAWO',
  'CLMOI',
  'EQVIC',
  'ZXHYM',
  'LIIGK',
  'ZRLMO',
  'XTCRT',
  'HBIVX',
  'WXRHJ',
  'BHANX',
  'BIHVX',
  'UFUGY',
  // 'CXVBH',
  'MQXUM',
  'JUDTL',
  'PNPSQ',
  'QOTIO',
  'XQKOS',
  'HNCHB',
  'QWDKM',
  'UZWGS',
  'NJSPD',
  'YJPBX',
  'FLKJR',
  'CTPTR',
  'RQRTZ',
  'GPCAA',
  'WOEZB',
  'UZQQU',
  'CBDXF',
  'HZKNJ',
  'CBLBL',
  'PHGTF',
  'CEAJN',
  'GIKFH',
  // 'FJUFJ',
  'TBJME',
  'HIYCI',
  'FZWNL',
  'EOTYY',
  'GSIXF',
  'XGGGW',
  'OGREC',
  'NDYRN',
  'OFRTR',
  'KLAGO',
  'GKJUM',
  'UOETH',
  'NBINF',
  'BKVLX',
  'MHCIY',
  'FXTWQ',
  'CMJEU',
  'UQUXP',
  'XFDAM',
  'BYOMG',
  'BPAXH',
  'TLTKY',
  'OKMNN',
  'WKPGO',
  'EWKXL',
  'AMIRJ',
  'YNCGC',
  'UIWBN',
  'VRQJH',
  'OQZOO',
  'FRDAQ',
  'ACHEM',
  'WZJZZ',
  'FCJHF',
  'OESPX',
  'ITEMU',
  'KGADL',
  'AJYSO',
  'JGCOW',
  'EVHRB',
  'RLNOG',
  'IIUDP',
  'ETOSU',
  'ONAOY',
  'LZRWM',
  'WLLPJ',
  'XSZLJ',
  'CBJND',
  'BNDWK',
  'ROAIA',
  'DDYNR',
  'FCAWI',
  'HDGDL',
  'LUTHR',
  'NZWLN',
  'WXASG',
  'HSYIO',
  'WGDIA',
  'CXMQK',
  'RZTCC',
  'ORGWO',
  'PFYTD',
  'PEGMY',
  'YIDKQ',
  'PEKOO',
  'LNUPJ',
  'OANOY',
  'RKTTT',
  'DTBCK',
  'KSXKO',
  'DRJKU',
  'XWKCG',
  'NSISK',
  'MLHJX',
  'VSCAO',
  'LXCZV',
  'JGUKQ',
  'MHXZR',
  'IMPMA',
  'NUDFZ',
  'QAYTX',
  'JZLAU',
  'ZZYJL',
  'OWZCC',
  'LRPYU',
  'MUJSA',
  'OZBXR',
  'LHNEG',
  'BWHTV',
  'EMOTV',
  'RBFEU',
  'ZQMIU',
  'CQENF',
  'RAVBV',
  'CSCVT',
  'XKKAE',
  'EBNVN',
  'JMWMM',
  'EQUBL',
  'EXAQI',
  'DLIPP',
  'PFMNH',
  'UNZZP',
  'IRYAA',
  'DCBXF',
  'BMTTL',
  'DJBWE',
  'XMUOO',
  'CSSDF',
  'KTESO',
  'CDQGO',
  'ICWDJ',
  'ZIHPD',
  'XPQTF',
  'UUSBZ',
  'DINRP',
  'MLMSE',
  'PDENF',
  'FEVJX',
  'YQMFX',
  'WDYSM',
  'UOUBT',
  'QTLHL',
  'UDYMS',
  'IZQGE',
  'JARBD',
  'LPRQG',
  'MSZEQ',
  'VYDVT',
  'UC4RF',
  'GFYSE',
  'TPMFB',
  'RNGNN',
  'FSSMW',
  'JFCDL',
  'OFLDT',
  'ZBXYQ',
  'CIOVJ',
  'SWXAI',
  'VSGCE',
  'NRSZN',
  'HKQUY',
  'SRWQO',
  'QJIGG',
  'QFWIS',
  'JTANB',
  'SAYZR',
  'UKROC',
  'VQKIY',
  'QWGFL',
  'OMEFD',
  'ZXMHT',
  'XSQAM',
  'CGDAI',
  'RHDEA',
  'EHCKW',
  'BMLPF',
  'MGQRR',
  'XXKNR',
  'MJOKQ',
  'GMVWE',
  'DHPUM',
  'LWOUG',
  'PWCAY',
  'RJGVV',
  'WXQAS',
  'MXCCS',
  'IVVXT',
  'HXMFV',
  'DPZWK',
]
